<template>
  <div>
    <el-table
      :data="tableData"
      border
      stripe>
      <el-table-column
        label="ID"
        type="index"
        align="center"
        width="70">
      </el-table-column>
      <el-table-column
        prop="warehouseCode"
        :label="$t('settings_accountThink_inventory_warehouseCode')"
        width="160">
      </el-table-column>
      <el-table-column
        prop="warehouseName"
        :label="$t('settings_accountThink_inventory_warehouseName')">
      </el-table-column>
      <el-table-column
        width="120"
        align="center"
        :label="$t('settings_accountThink_inventory_operations')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="select(scope.row)">Select</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import moment from 'moment'
  import axios from 'axios'
  export default {
    name: 'business-unit-warehouses',
    data() {
      return {
        moment: moment,
        tableData: []
      }
    },
    methods: {
      async openTab() {
        await this.getList()
      },
      async getList() {
        let loader = this.$loading.show();
        try {
          const { data } = await axios.get(`/api/v1/inventories/list/bu?buId=${this.$route.query.businessUnitId}`)
          this.tableData = data.inventory
        } catch (error) {
          console.log(error)
        } finally {
          loader.hide()
        }
      },
      select(row) {
        this.$router.push({name: 'bu-warehouse-management', query: { companyId: this.$route.query.companyId, warehouseId: row.id }} )
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
